import { render } from "./Lotto.vue?vue&type=template&id=34296314&scoped=true"
import script from "./Lotto.vue?vue&type=script&lang=js"
export * from "./Lotto.vue?vue&type=script&lang=js"

import "./Lotto.vue?vue&type=style&index=0&id=34296314&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34296314"]])

export default __exports__